import React from 'react';
import { Link } from 'react-router-dom'
import TextField from 'material-ui/TextField';
import {Row,Col} from 'react-bootstrap'
import RaisedButton from 'material-ui/RaisedButton';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../../Actions/users';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import {Helmet} from "react-helmet";

class Login extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      usernameReq: false,
      passwordReq: false,
      information: 'deactivate-information',
      modalIsOpen: false,
      emailReqText: '',
      PassreqText: '',
      buttonDisable: false,
      redirecturl: null
    }
    this.InformationToggle = this.InformationToggle.bind(this);
    this.loginSubmit = this.loginSubmit.bind(this);
    this.forgetPassword = this.forgetPassword.bind(this);
    this.closeModalPopup= this.closeModalPopup.bind(this);
  }

  InformationToggle(){
        let value =  (this.state.information === 'deactivate-information') ? 'active-information' : 'deactivate-information' 
        this.setState({ information : value });
  }
  componentWillReceiveProps(nextProps){   
      let checkButtonstatus=nextProps.login.disableButtonLogin;
      this.setState({buttonDisable:checkButtonstatus});

      // console.log('sign up data', this.props.signup);
      // console.log('new props', nextProps);
        if(typeof(nextProps.signup.redirecturl) !== 'undefined' && nextProps.signup.redirecturl !== null){
          // this.setState({redirecturl: nextProps.signup.redirecturl})
          setTimeout(()=>{
            this.props.history.push(nextProps.signup.redirecturl);
          }, 3000) 
        }
  }

  // submit login form
  loginSubmit(e) {
      e.preventDefault();
      var username= document.loginForm.username.value;
      var password= document.loginForm.password.value;

      if(username===''){
          this.setState({usernameReq:true,emailReqText:'Please enter a valid email.'});
          return false;
      }else{
          this.setState({emailReqText:''});
      }
      if(password===''){
          this.setState({passwordReq:true,PassreqText:'Please enter a valid password.'});
          return false;
      }else{
          this.setState({PassreqText:''});
      }
      if( username && password ) {
        this.setState({buttonDisable:true});
        this.props.authenticate(username, password);
      }     
  } 
  // hadle onclick on forget paswword link
  forgetPassword(){
      var username= document.loginForm.username.value;
      if(username){
        this.props.authenticateUserEmail(username);
      }else{
        this.setState({usernameReq:true,emailReqText:'Please enter a valid email.'});
        return false;
      }
  }   
  closeModalPopup(){
      this.setState({modalIsOpen: false});
      this.props.resetForgetPopup();
    }
  check(){
    if(this.props.login.authenticatingEmail){
        var username= document.loginForm.username.value;
        this.props.sendForgatPassEmail(username);
        this.setState({modalIsOpen: true});
    }
  }
  render() {
    let check=!this.state.modalIsOpen?this.check():null;
    let today = new Date().getFullYear()
    const action = [
          <FlatButton
            label="ok"
            primary={true}
            onClick={this.closeModalPopup}
          />
        ];
      return(<div>
              <Helmet>
                <meta charSet="utf-8" />
                  <title>Login</title>
                  <link rel="stylesheet" type="text/css" href="/css/table.css" />
              </Helmet>
                <div className="signup-page login">
                    <div className={`signup-right col-6  ${this.state.information}`}>
                        <div className="login-logo">
                            <div className="margin-auto">
                               <h3><Link to ="">Welcome To Dokkit</Link></h3>
                            </div>
                        </div>
                    </div>
                    <div className="signup-left col-6">
                         <div className="show-information vissible-sm vissible-xs"  onClick={this.InformationToggle}>
                              <i className="zmdi zmdi-info"></i>
                          </div>
                         <div className="right-content display-flex">
                             <div className="signup-form-section">
                                 <form name="loginForm" onSubmit={this.loginSubmit}>
                                    <figure>
                                      <Link to="/">
                                        <img src="/images/dokkit-logo.png" alt="logo-icon" />
                                      </Link>
                                    </figure>
                                    <h3>Please Sign In to get access</h3>
                                     <Row>
                                        <Col md={12}>
                                            <TextField
                                                hintText="Enter Email Id"
                                                fullWidth={ true }
                                                floatingLabelText="User email"
                                                name="username"
                                                type="email"
                                                required={this.state.usernameReq}
                                                errorText={this.state.emailReqText}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12} className="margb20px">
                                            <TextField
                                                hintText="Enter Password"
                                                fullWidth={ true }
                                                floatingLabelText="Password *"
                                                type="password"
                                                name="password"
                                                required={this.state.passwordReq}
                                                errorText={this.state.PassreqText}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="display-flex">
                                        <Col md={6}>
                                           <Link to='#' className="color-blue" onClick={this.forgetPassword}>
                                              forgot password?
                                            </Link>
                                        </Col>
                                        <Col md={6}>
                                          <div className="forgotten-password">
                                            <RaisedButton label="Sign IN" type="submit" labelColor="#fff" fullWidth={false} disabled={this.state.buttonDisable?true:false}/>
                                          </div>
                                        </Col>
                                    </Row>
                                  </form>
                             </div>
                             {this.props.login.authenticatingEmail?  
                             <Dialog 
                                    actions={action}
                                    className="model-support"
                                    modal={false}
                                    contentClassName="model-top-overlay no-overlay"
                                    open={ this.state.modalIsOpen}
                                    onRequestClose={this.closeModal}
                                  > 
                                 <div className="other-popup-content learn-more-popup">
                                    <h2>An email has been sent to your email address with a reset link.</h2>
                                 </div>
                              </Dialog>
                                : null }
                             <div className="copyright-footer">
                                <p>&copy; {today.toString()} Dokkit All rights reserved.</p>
                             </div>     
                        </div>   
                    </div>
                </div>       
             </div>    
      )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    login: state.login,
    signup: state.signup
  };
};

Login = withRouter(connect(
  mapStateToProps,
  actions
)(Login));

export default Login;



// WEBPACK FOOTER //
// ./src/Components/Modules/LoginSignup/Login.js